module.exports = __webpack_public_path__ + "img/charme_black_ba_detail_rsh2(1).d0122926.jpg";